// extracted by mini-css-extract-plugin
export default {"container":"Cb0OhdrRtovGor4J6xLE__container___"};